import { useMemo } from "react";

import { ByokSection } from "./byok-section/ByokSection";
import { CTASection } from "./cta-section/CTASection";
import { EcosystemSection } from "./ecosystem-section/EcosystemSection";
import { FAQSection } from "./faq-section/FAQSection";
import { Footer } from "./footer/Footer";
import { GetTheAppSection } from "./get-app-section/GetTheAppSection";
import { Header } from "./header/Header";
import { HeroSection } from "./hero-section/HeroSection";
import { KnowledgeSection } from "./knowledge-section/KnowledgeSection";
import { PrivacySection } from "./privacy-section/PrivacySection";
import { ProcessSection } from "./process-section/ProcessSection";
import { StructuredData } from "./structured-data/StructuredData";
import { TrustBar } from "./trust-bar/TrustBar";

export function LandingPage() {
  const animationCss = useMemo(
    () => `
      @keyframes landing-float {
        0%, 100% { transform: translateY(0) rotate(-1deg); }
        50% { transform: translateY(-14px) rotate(1deg); }
      }
      @keyframes landing-float-slow {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
      .landing-float { animation: landing-float 8s ease-in-out infinite; }
      .landing-float-slow { animation: landing-float-slow 7s ease-in-out infinite; }
      .landing-float-slower { animation: landing-float-slow 9s ease-in-out infinite; }
      @media (prefers-reduced-motion: reduce) {
        .landing-float,
        .landing-float-slow,
        .landing-float-slower { animation: none; }
      }
    `,
    [],
  );

  return (
    <div className="min-h-screen overflow-x-hidden bg-background text-foreground">
      <StructuredData />
      <style>{animationCss}</style>
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <EcosystemSection />
        <ProcessSection />
        <KnowledgeSection />
        <PrivacySection />
        <ByokSection />
        <GetTheAppSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
